<template>
  <Icon
      :name="formatToFileName(getDepartmentDisplayName(departmentName))"
      :color="$vuetify.theme.themes.light.primary"
      :class="classes.imageSize"
      :title="getDepartmentDisplayName(departmentName)+' department icon'"
      :no-image="true"
  ></Icon>
</template>

<script>
import { mapState} from "vuex";
import {formatToFileName} from "@/util.js";
import Icon from '@/components/UI/Icon.vue'

const classes = {
  xs: {
    imageSize: "product-image-size-xs",
  },
  sm: {
    imageSize: "product-image-size-sm",
  },
  md: {
    imageSize: "product-image-size",
  },
  lg: {
    imageSize: "product-image-size-lg",
  },
};

export default {
  name: "NoImageAvailable",
  components: {Icon},
  data() {
    return {
      classes: classes[this.size],
    };
  },
   computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  methods: {
    formatToFileName,
    getDepartmentDisplayName(departmentName){
      if(departmentName== 'Menu' && this.storeInfo.menu_as_featured){
        return 'Featured';
      }
      return departmentName;
    }
  },
  props: { departmentName: String, size: String },
};
</script>
